import(/* webpackChunkName: "infolinkmodule" */ '../../Styles/LinkList/infolinkmodule.scss');

await import(/* webpackChunkName: "sync" */ 'Feature/Common/code/Scripts/Common/sync');
await import(/* webpackChunkName: "parents" */ 'Feature/Common/code/Scripts/Common/parents');

window.am = window.am || {};

window.am.infoLinkList = new function () {
    var that = this;

    that.onResize = function () {
        let allInfoTextElements = document.querySelectorAll('.info-linklist__infotext, .info-linklist__infotext--mobile');
        if (allInfoTextElements && allInfoTextElements.length > 0) {
            allInfoTextElements.forEach(function (infoTextEl) {
                if (!infoTextEl.classList.contains('d-none')) {
                    if (window.innerWidth < 768 && !infoTextEl.classList.contains('info-linklist__infotext--mobile')) {
                        infoTextEl.classList.add('d-none');
                        let infoTextElLinkItem = infoTextEl.previousElementSibling.querySelector('.info-linklist__item--open');
                        if (infoTextElLinkItem) {
                            infoTextElLinkItem.classList.remove('info-linklist__item--open');
                        }

                    }
                    else if (window.innerWidth > 767 && infoTextEl.classList.contains('info-linklist__infotext--mobile')) {
                        infoTextEl.classList.add('d-none');
                        
                        let infoTextElLinkItem = infoTextEl.previousElementSibling;
                        if (infoTextElLinkItem && infoTextElLinkItem.classList.contains('info-linklist__item--open')) {
                            infoTextElLinkItem.classList.remove('info-linklist__item--open');
                        }
                    }
                    
                }
            })
        }
    };

    that.init = function () {
        const infoLinktems = document.querySelectorAll('.info-linklist__item');
        
        if (infoLinktems && infoLinktems.length > 0) {
            infoLinktems.forEach(function (infoLinkItem) {
                
                    let infoIconItem = infoLinkItem.querySelector('.info-linklist__info-icon');
                    if (infoIconItem) {
                        infoLinkItem.addEventListener('click', function (event) {

                            let infoText = event.currentTarget.getAttribute('data-infotext');

                            if (window.innerWidth < 768) {
                                var infoTextElement = event.currentTarget.nextElementSibling;
                            }
                            else {
                                let containerParent = event.currentTarget.parent('.info-linklist__container')
                                var infoTextElement = containerParent.nextElementSibling;
                            }

                            if (infoTextElement) {

                                if (event.currentTarget.classList.contains('info-linklist__item--open')) {
                                    event.currentTarget.classList.remove('info-linklist__item--open');
                                    infoTextElement.classList.add('d-none');
                                } else {
                                    infoTextElement.innerText = infoText;
                                    infoTextElement.classList.remove('d-none');
                                    event.currentTarget.classList.add('info-linklist__item--open');
                                }
                            }

                        });
                    }               
            })                        
        }

        window.addEventListener("resize", that.onResize);
        that.onResize();
    };
};

window.am.infoLinkList.init();